<script setup lang="ts">
import { TextSecondaryMedium } from '@shared/ui/typography'

defineOptions({
  name: 'FormRow',
})

withDefaults(defineProps<FormRowProps>(), {
  label: '',
  required: false,
})

interface FormRowProps {
  label?: string
  required?: boolean
}

</script>

<template>
  <div class="form-row">
    <TextSecondaryMedium v-if="label">
      {{ label }}
      <span
        v-if="required"
        class="form-row__required"
      >
        *
      </span>
    </TextSecondaryMedium>
    <div class="form-row__content">
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./FormRow.scss" />